<div *ngIf="hasImports()" class="toast-container">
  <div
    *ngFor="let importData of getImportArray(); trackBy: trackByImportId"
    class="toast-item"
    [ngClass]="getToastClasses(importData.status)"
  >
    <!-- Progress bar overlay -->
    <div 
      *ngIf="importData.status === 'in_progress'" 
      class="progress-bar-overlay"
      [style.width.%]="getProgressPercentage(importData)"
    ></div>
    
    <!-- Status indicator -->
    <!-- <div class="status-indicator" [ngClass]="getStatusIndicatorClass(importData.status)">
      <div class="status-icon">
        <i-tabler 
          [name]="getStatusIcon(importData.status)" 
          class="w-4 h-4"
        ></i-tabler>
      </div>
    </div> -->

    <!-- Content -->
    <div class="toast-content">
      <div class="toast-header">
        <h4 class="toast-title">
         Importing {{ getImportTypeDisplay(importData.importType) }}
        </h4>
        <button
          (click)="closeImport(importData.importId)"
          class="close-button"
          type="button"
          aria-label="Close notification"
        >
          <i-tabler name="x" class="w-4 h-4"></i-tabler>
        </button>
      </div>
      
  

      <!-- Progress section -->
      <div *ngIf="importData.status === 'in_progress' || importData.status === 'completed'" class="progress-section">
        <div class="progress-info">
          <span class="progress-text">
            {{ importData.importedRecords }} of {{ importData.totalRecords }} records
          </span>
          <span class="progress-percentage">
            {{ getProgressPercentage(importData) }}%
          </span>
        </div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            [ngClass]="getProgressFillClass(importData.status)"
            [style.width.%]="getProgressPercentage(importData)"
          ></div>
        </div>
      </div>

      <!-- Status messages -->
      <div *ngIf="importData.status === 'completed'" class="status-message success">
        <i-tabler name="check-circle" class="w-4 h-4"></i-tabler>
        <span>
          Import completed successfully!
          <ng-container *ngIf="getSkippedCount(importData) > 0">
            {{ getSkippedCount(importData) }} duplicate record{{ getSkippedCount(importData) === 1 ? '' : 's' }} skipped.
          </ng-container>
        </span>
      </div>

      <div *ngIf="importData.status === 'failed'" class="status-message error">
        <i-tabler name="alert-circle" class="w-4 h-4"></i-tabler>
        <span>{{ importData.errorMessage || 'Import failed' }}</span>
      </div>
    </div>
  </div>
</div>
